import { render } from "./PaymentModal.vue?vue&type=template&id=357bf404&scoped=true&ts=true"
import script from "./PaymentModal.vue?vue&type=script&lang=ts"
export * from "./PaymentModal.vue?vue&type=script&lang=ts"

import "./PaymentModal.vue?vue&type=style&index=0&id=357bf404&scoped=true&lang=css"

import exportComponent from "/builds/moneyspace/moneyspace_homepage_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-357bf404"]])

export default __exports__